export const HEADERS = [
  'HEADER.ID',
  'HEADER.NAME',
  'HEADER.DESCRIPTION',
  'HEADER.IS-PRIVATE',
  'HEADER.REQUEST_PREMIUM',
  'HEADER.CREATED',
  'HEADER.PUBLIC_CODE',
];
